module.exports = __webpack_public_path__ + "img/swiper11.7b45370b.png";